/* THE BUY ROW. Draws price and ADD under any product card, and a panel under
   that for colour and size, and puts the shirt in the cart without leaving the
   page.

   Adam's ask, 29 Aug 2026, was the row itself. The look was settled off mockups
   the same day, the reasons behind each choice are written in
   snippets/wr-buy.liquid. Styles are in assets/wr-buy.css.

   THE PANEL. His call, 4 Sep 2026, off a preview on his phone: "there is too
   much text on the website". The colour and size words came off the row, on the
   phone AND the computer. The row is now price on the left and ADD on the
   right, nothing else. Pressing ADD opens a panel under that one shirt: a row
   of colour dots, then the sizes as chips. Nothing is asked of the shopper
   until they have said they want the shirt.

   CHOOSING NEVER TOUCHES THE CART. His brief, 2 Oct 2026, board job 343, and
   it replaces his 7 Sep 2026 rule that the second of the two presses buys and
   a change afterwards swaps what is in the cart. The button on the row reads
   "Pick a size." (his own words, typed into the look page that morning, after
   "Choose options" came back as "not brand and too long") and it only ever
   opens and shuts the panel. In the panel a colour dot rings and swaps the
   photo, a size box lights, the price follows the size, and both can be
   changed as often as he likes: nothing is added, taken out or swapped by any
   of it. At rest no dot is ringed and no size box is lit, as before.

   Under the sizes sits a separate "Add to cart" button. It is a plain frame
   until a colour and a size are both pressed and that pair can be bought, and
   brown after that. It is the ONE place in a row that puts a shirt in the cart.

   WHEN THE SHIRT HAS GONE IN, a box opens in the middle of the screen (his
   pick, "exactly as example number two"): the tilted "Added to cart." tag, the
   photo in the colour chosen, the sentence, colour and size, the price, and
   two buttons. Keep shopping shuts the box and leaves him exactly where he was.
   View cart goes to /cart. The card folds shut and its choice is cleared, so
   the next shirt is a fresh choice, and its photo carries a small brown
   "In cart" mark for as long as any colour or size of that shirt is in the
   cart. The row's button never turns ADDED any more: a button that only opens
   the choices must not look like the thing that buys.

   The 7 Sep wording and the whole second-press-buys machinery are kept in
   backups/BACKUP-LIVE-wr-buy-2026-10-02-before-pick-a-size.js.txt.

   The old dropdown machinery (our own black and white list, lifted to the end
   of the page so the footer could not cover it) is gone with the words it drew.
   The story is in whateverrr/HANDOFF-ARCHIVE.md under 29 Aug 2026.

   Plain old script, no modules, no build step. It runs once, finds every
   .wr-buy on the page and fills it in. Cards that are made by JavaScript after
   the page has loaded (the home page) call window.wrBuy.scan() when they are
   done.

   HOW IT ADDS TO THE CART. It posts to Shopify's own /cart/add.js. The cart
   drawer still does NOT slide open, his call 29 Aug 2026: a shopper browsing
   two hundred sentences should keep browsing. Since 2 Oct 2026 the Added to
   cart box says the shirt has gone in, and the number by the cart goes up.
   Nothing here re-implements the cart. */

(function () {
  if (window.wrBuy) return;

  /* WHAT IS IN THE CART, READ OFF THE REAL CART.
     Adam, 29 Aug 2026: "when you press it again it resets it and it goes back
     to add". Holding the green ADDED on the button itself was not enough,
     because a card can be drawn again from scratch after the cart changes and
     the new button knows nothing. So the memory lives up here, on the page, not
     on the button, keyed by the exact variant.

     AND IT SURVIVES LEAVING THE PAGE. His catch, 4 Sep 2026: "when I page and
     I come back the button is resetting itself, it needs to stay green until
     the checkout or the cancellation". So this is no longer the page's own
     memory: on every page it is filled from Shopify's own /cart.js first. It
     is refilled after every add, and whenever the theme's own cart (the
     slide-out bag, the cart page) says the lines changed.

     SINCE 2 Oct 2026 THE GREEN BUTTON IS GONE and this memory feeds two things:
     the small "In cart" mark on a card's photo, which shows for as long as any
     colour or size of that shirt is in the cart and goes the moment the last
     one is taken out in the bag, and the ADDED on the one shirt and one hoodie
     features of the home page, which still work the way they did. */
  var addedIds = {};
  var syncers = [];

  function readCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        Object.keys(addedIds).forEach(function (k) { delete addedIds[k]; });
        /* the HOW MANY is kept, not just a yes. A swap (see putIn) has to put
           the new colour in at the same number the old one was in at. */
        (cart.items || []).forEach(function (item) { addedIds[item.variant_id] = item.quantity || 1; });
        return addedIds;
      })
      .catch(function () { return addedIds; });
  }

  function syncAll() {
    syncers.forEach(function (fn) { try { fn(); } catch (err) { } });
  }

  var cartReady = readCart();

  /* the theme's own cart changed (a remove in the slide-out bag, the cart
     page, a quantity change): once its promise settles, read the cart again
     and redraw every row. Events this script sent itself are skipped, those
     rows were already brought up to date by hand. */
  document.addEventListener('shopify:cart:lines-update', function (ev) {
    if (ev && ev.wrBuy) return;
    var wait = (ev && ev.promise) ? ev.promise : Promise.resolve();
    wait.then(readCart, readCart).then(syncAll);
  });

  /* AND WHAT HE HAD CHOSEN ON EACH SHIRT. Same reason as above. When a card is
     drawn again the new panel would start on the first colour, which reads as
     the card forgetting him even when the cart is fine. This holds the last
     colour and size he picked on each shirt so a redrawn card comes back
     exactly as he left it. Keyed by the shirt's own address. */
  var lastPick = {};

  /* ONE PANEL OPEN AT A TIME. Opening a second shirt's panel closes the first,
     so the page never grows two open panels that push everything about. */
  var openPanel = null;

  function shutPanel() {
    if (!openPanel) return;
    openPanel.classList.remove('is-open');
    openPanel = null;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    /* the Added to cart box shuts first; a second press folds the open panel */
    if (addedBox && addedBox.wrap.classList.contains('is-open')) hideAdded();
    else shutPanel();
  });

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text) node.textContent = text;
    return node;
  }

  /* THE ADDED TO CART BOX. His brief 2 Oct 2026, and his pick of the two looks
     he was shown that morning: "exactly as example number two when pop up box
     open". One box for the whole page, made the first time a shirt goes in and
     hung on the end of the page, outside every section, so no band can clip it
     and the line in the theme settings that wipes inline colours inside the
     page body cannot reach it. Nothing in it is coloured from a style
     attribute; the look is all in assets/wr-buy.css.

     What it says is what actually went in: the sentence comes off Shopify's
     own answer to the add, the colour, the size and the price are the ones on
     the card at the moment of the press, and the photo is that colour's own.

     KEEP SHOPPING shuts it and nothing else: the page does not move, the card
     is where he left it. So do the cross, a press on the dark around the box,
     and Escape. VIEW CART is a plain link to the cart page; the "We are not
     open yet." note there is untouched and Check out stays shut. */
  var addedBox = null;
  var addedBack = null;

  function cartUrl() {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return base + 'cart';
  }

  function buildAdded() {
    var wrap = el('div', 'wr-added');
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', 'Added to cart');
    var box = el('div', 'wr-added__box');
    var x = el('button', 'wr-added__x', '×');
    x.type = 'button';
    x.setAttribute('aria-label', 'Close');
    var tag = el('p', 'wr-added__tag');
    tag.appendChild(el('span', '', 'Added to cart.'));
    var item = el('div', 'wr-added__item');
    var ph = el('div', 'wr-added__ph');
    var img = el('img');
    img.alt = '';
    ph.appendChild(img);
    var txt = el('div', 'wr-added__txt');
    var name = el('p', 'wr-added__name');
    var opt = el('p', 'wr-added__opt');
    var cost = el('p', 'wr-added__price');
    txt.appendChild(name);
    txt.appendChild(opt);
    txt.appendChild(cost);
    item.appendChild(ph);
    item.appendChild(txt);
    var btns = el('div', 'wr-added__btns');
    var keep = el('button', 'wr-added__keep', 'Keep shopping');
    keep.type = 'button';
    var view = el('a', 'wr-added__view', 'View cart');
    view.href = cartUrl();
    btns.appendChild(keep);
    btns.appendChild(view);
    box.appendChild(x);
    box.appendChild(tag);
    box.appendChild(item);
    box.appendChild(btns);
    wrap.appendChild(box);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) hideAdded(); });
    x.addEventListener('click', hideAdded);
    keep.addEventListener('click', hideAdded);
    document.body.appendChild(wrap);
    return { wrap: wrap, ph: ph, img: img, name: name, opt: opt, cost: cost, keep: keep };
  }

  function showAdded(said) {
    try {
      if (!addedBox) addedBox = buildAdded();
      var b = addedBox;
      b.name.textContent = said.name || '';
      b.opt.textContent = [said.color, said.size].filter(function (x) { return !!x; }).join(' / ');
      b.cost.textContent = said.price || '';
      if (said.img) { b.img.src = said.img; b.ph.classList.remove('is-empty'); }
      else { b.img.removeAttribute('src'); b.ph.classList.add('is-empty'); }
      addedBack = said.back || null;
      b.wrap.classList.add('is-open');
      /* the keyboard lands on Keep shopping, without the page jumping to it */
      try { b.keep.focus({ preventScroll: true }); } catch (err) { }
    } catch (err) { }
  }

  function hideAdded() {
    if (!addedBox) return;
    addedBox.wrap.classList.remove('is-open');
    if (addedBack && addedBack.focus) { try { addedBack.focus({ preventScroll: true }); } catch (err) { } }
    addedBack = null;
  }

  /* a photo address at the small size the box needs, so a 2048px picture is
     never fetched to fill a 140px square */
  function sized(url, w) {
    url = String(url || '');
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + w);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* the line Shopify says it added, out of its answer to /cart/add.js */
  function lineOf(response, id) {
    var items = (response && response.items) || ((response && response.variant_id) ? [response] : []);
    for (var i = 0; i < items.length; i++) {
      if (items[i] && items[i].variant_id === id) return items[i];
    }
    return items[0] || null;
  }

  /* THE SMALL "IN CART" MARK ON A CARD'S PHOTO. It takes over the one job the
     green ADDED button had that he fought for twice (29 Aug and 4 Sep 2026: "I
     could not tell any more which shirts I had taken", "it needs to stay until
     the checkout or the cancellation"): a shopper back on the shelf can see
     what he has already taken. Shown to him on the look pages of 2 Oct 2026 and
     passed with the rest.

     WHERE IT HANGS. In the top left corner of the photo, so it has to be put
     inside whatever box holds that photo, and each kind of card keeps its photo
     somewhere different (read off the live shop 2 Oct 2026):
       - both home pages and the Everything page: the photo sits alone inside
         its own link (a.wrhp-photo, a.wrhr-photo, a.ph). The mark goes in that
         link. On the tilted cards the link is the thing that is turned, so the
         mark turns with the photo.
       - the theme's own cards (group pages, search, the strip under a shirt,
         the cart page): the photos are a slideshow inside .card-gallery, and
         the mark goes in the gallery.
       - a card that keeps its photo loose beside the sentence has no box to
         hang it on and gets no mark, rather than a mark in the wrong place.
     The box only gets position: relative when it has no position of its own. */
  function photoBox(row) {
    var box = row.parentElement;
    while (box && box !== document.body) {
      var gallery = box.querySelector('.card-gallery');
      if (gallery) return gallery;
      var pic = box.querySelector('img, svg image');
      if (pic) {
        var frame = pic.tagName.toLowerCase() === 'image' ? pic.ownerSVGElement : pic;
        var host = frame ? frame.parentElement : null;
        return (host && host !== box && !host.contains(row)) ? host : null;
      }
      box = box.parentElement;
    }
    return null;
  }

  function setMark(row, on) {
    var mark = row.__wrInCart;
    if (mark && !document.documentElement.contains(mark)) mark = row.__wrInCart = null;
    if (!on) {
      if (mark) { mark.parentNode.removeChild(mark); row.__wrInCart = null; }
      return;
    }
    if (mark) return;
    var host = photoBox(row);
    if (!host) return;
    if (getComputedStyle(host).position === 'static') host.classList.add('wr-incart-host');
    mark = el('span', 'wr-incart', '✓ In cart');
    host.appendChild(mark);
    row.__wrInCart = mark;
  }

  /* WHAT COLOUR EACH DOT IS PAINTED. The shop sells shirts in Black, Gray and
     White and hoodies in Black and Bone (read off the live store 4 Sep 2026).
     A colour that is not in this list still gets a dot, a plain mid grey one,
     with its name as the hover text, so a new colour can never break the row. */
  var SWATCH = {
    black: '#000000',
    gray: '#8b8b8b',
    grey: '#8b8b8b',
    white: '#f4f2ee',
    bone: '#e9e3d2',
    cream: '#e9e3d2'
  };

  function swatchFor(name) {
    return SWATCH[String(name || '').toLowerCase()] || '#777777';
  }

  /* EVERY PHOTO ON THIS CARD.
     Each kind of card keeps its picture somewhere different, so instead of
     guessing a class name this walks up from the row until it finds the first
     box that holds any picture at all, and takes every picture in it.

     It starts at the row's PARENT on purpose. closest() counts the element
     itself, and the row is a div, so asking it for the nearest div handed back
     the row, which holds no picture, and the colour never changed the photo.
     Adam caught that on the preview, 29 Aug 2026.

     All the pictures in the card are changed, not just one. The Everything page
     stacks two, the bag-person shot on top of the flat shot, and only the black
     bag shot exists. Changing one would have left a black photo showing while
     the dot said White. */
  function cardImages(row) {
    var el = row.parentElement;
    while (el && el !== document.body) {
      var found = el.querySelectorAll('img');
      if (found.length) return Array.prototype.slice.call(found);
      el = el.parentElement;
    }
    return [];
  }

  /* Shopify's cards often wrap a picture in <picture> with <source srcset>,
     and a source beats the img's own src. Both have to be cleared or the
     photo does not change. */
  function showPhoto(imgs, url) {
    if (!url) return;
    imgs.forEach(function (img) {
      var picture = img.parentElement;
      if (picture && picture.tagName === 'PICTURE') {
        Array.prototype.forEach.call(picture.querySelectorAll('source'), function (s) {
          s.removeAttribute('srcset');
        });
      }
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = url;
    });
  }

  /* ON THE SHIRT'S OWN PAGE A COLOUR DOT TURNS THE BIG GALLERY, it does not
     swap a photo. That page shows every picture of the shirt in a slideshow,
     and painting all of them the one colour would be wrong. So the row finds
     the slide that holds that colour's picture (each picture carries its own
     media id, and the JSON carries the id of each colour's picture) and asks
     the theme's own slideshow to go there. His call 4 Sep 2026. */
  function jumpGallery(row, mediaId) {
    if (!mediaId) return;
    var section = row.closest('.shopify-section') || document;
    Array.prototype.forEach.call(section.querySelectorAll('media-gallery'), function (g) {
      var slides = g.querySelectorAll('slideshow-slide');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].querySelector('[data-media-id="' + mediaId + '"]')) {
          if (g.slideshow && g.slideshow.select) g.slideshow.select(i);
          return;
        }
      }
    });
  }

  /* THE CART DRAWER DOES NOT OPEN ON ADD. Adam's call, 29 Aug 2026: he sells
     one sentence at a time and has over two hundred of them, so a shopper who
     is browsing should keep browsing. A panel sliding over the page stops that
     dead. The proof it worked used to be the button turning green and the
     number by the cart going up. Since 2 Oct 2026, his brief, the proof is the
     Added to cart box, which he shuts with one press and is back where he was;
     the number by the cart still goes up here, and the drawer still stays shut. */
  function bumpCartCount() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count;
        countOnPage = n;
        Array.prototype.forEach.call(document.querySelectorAll('.cart-bubble'), function (bubble) {
          /* an empty cart shows no number at all, or taking the last shirt back
             out would leave a little 0 sitting by the cart */
          if (n < 1) { bubble.classList.add('visually-hidden'); return; }
          bubble.classList.remove('visually-hidden');
          var count = bubble.querySelector('.cart-bubble__text-count');
          if (count) {
            count.classList.remove('hidden');
            count.textContent = n > 99 ? '' : String(n);
          }
        });
        return cart;
      })
      .catch(function () { return null; });
  }

  /* the last count this script read off the real cart, so a failed read can
     still hand the theme a true number instead of nothing */
  var countOnPage = null;

  function countOf(cart) {
    if (cart && typeof cart.item_count === 'number') return cart.item_count;
    if (typeof countOnPage === 'number') return countOnPage;
    var shown = document.querySelector('.cart-bubble__text-count');
    var n = shown ? parseInt(shown.textContent, 10) : NaN;
    return isNaN(n) ? 0 : n;
  }

  /* THE SLIDE-OUT BAG AND THE CART PAGE MUST HEAR ABOUT IT. Adam's catch,
     4 Sep 2026, twice: "he doesn't remove product from the cart". The cart
     itself was right every time, but the bag he opened afterwards still showed
     the old list, because the theme only redraws that list when it hears its
     own "shopify:cart:lines-update" event, and this script never sent one.
     (The old refresh here called a method the theme no longer has.)

     So every cart call now asks Shopify for the fresh HTML of each cart list
     on the page (the "sections" field, exactly what the theme's own add form
     sends, see assets/product-form.js), and afterwards the same event the
     theme's form sends is fired on the page with that HTML attached. The bag
     and the cart page redraw themselves from it. The event is sent from the
     page, not from inside the list, because the list ignores its own.

     THE MESSAGE MUST CARRY THE COUNT. His report, 4 Sep 2026: "sometimes the
     cart resets". The shirts were never lost, the number by the cart went
     blank. The theme's cart icon (assets/cart-icon.js) listens to this same
     event and reads the count out of it; when none is sent it takes zero,
     hides the number and writes that zero into the browser's short memory.
     On the next page, within ten seconds, it trusts that memory over the
     real number and hides it again. So the event now waits for the fresh
     count from /cart.js (the same read that bumps the number) and hands it
     over as itemCount, exactly as the theme's own forms do. */
  function cartSectionIds() {
    var ids = [];
    Array.prototype.forEach.call(document.querySelectorAll('cart-items-component'), function (el) {
      if (el.dataset && el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function tellCart(action, response, counted) {
    var wait = (counted && counted.then) ? counted : Promise.resolve(null);
    try {
      var ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true, cancelable: false });
      ev.wrBuy = true;
      ev.action = action;
      ev.context = 'standard-action';
      ev.promise = wait.then(function (cart) {
        return {
          cart: null,
          detail: {
            sections: (response && response.sections) || {},
            source: 'wr-buy',
            didError: false,
            itemCount: countOf(cart)
          }
        };
      }, function () {
        return {
          cart: null,
          detail: { sections: (response && response.sections) || {}, source: 'wr-buy', didError: false, itemCount: countOf(null) }
        };
      });
      document.dispatchEvent(ev);
    } catch (err) { }
    return wait.then(function () { }, function () { });
  }

  /* A PRICE WRITTEN THE WAY THE PAGE WRITES ITS OWN. /products/<name>.js gives
     a price as a bare number of cents; the row was handed its starting price
     as words by the page ("$34.99"). The number is dropped into the place the
     digits hold in those words, so the sign and its side stay whatever the
     page chose. No words to copy, or cents that are not a number: no price,
     and the row keeps showing the starting one. */
  function priceLike(sample, cents) {
    if (typeof cents !== 'number' || !isFinite(cents)) return '';
    var m = String(sample || '').match(/^(\D*)[\d.,]+(.*)$/);
    if (!m) return '';
    return m[1] + (cents / 100).toFixed(2) + m[2];
  }

  /* Shopify's own /products/<name>.js turned into the same shape the Liquid
     snippet writes. Used by the home page, where only a handful of shirts out
     of the whole shop ever get drawn, so sending every shirt's sizes and colours
     with the page would be 282KB of waste. Measured 29 Aug 2026.

     EACH SIZE CARRIES ITS OWN PRICE since 2 Oct 2026. His brief: "they choose
     color and size and see the correct price". Until then only the Liquid
     kind of row knew that 2XL and 3XL cost more; a row filled from here, which
     is every card on both home pages and the Everything page, kept showing
     the starting price whatever size was lit. */
  function fromShopify(json, price) {
    var sizeIdx = -1;
    var colorIdx = -1;
    (json.options || []).forEach(function (o, i) {
      var name = o.name || o;
      if (name === 'Size') sizeIdx = i;
      if (name === 'Color') colorIdx = i;
    });
    if (sizeIdx < 0) return null;

    var sizes = [];
    var colors = [];
    var seen = {};
    var map = {};

    (json.variants || []).forEach(function (v) {
      var s = v.options[sizeIdx];
      var c = colorIdx >= 0 ? v.options[colorIdx] : '';
      if (sizes.indexOf(s) === -1) sizes.push(s);
      if (c && !seen[c]) {
        seen[c] = 1;
        colors.push({ n: c, img: v.featured_image ? v.featured_image.src : '' });
      }
      map[c + '|' + s] = [v.id, v.available ? 1 : 0, priceLike(price, v.price)];
    });

    return { u: '/products/' + json.handle, t: json.title || '', p: price || '', sizes: sizes, colors: colors, map: map };
  }

  function build(row) {
    if (row.dataset.wrBuyReady === '1') return;
    row.dataset.wrBuyReady = '1';

    var handle = row.getAttribute('data-wr-handle');
    if (handle) {
      fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var data = fromShopify(json, row.getAttribute('data-wr-price'));
          if (data) render(row, data);
        })
        .catch(function () { });
      return;
    }

    var data;
    try {
      data = JSON.parse(row.getAttribute('data-wr-buy'));
    } catch (err) {
      return;
    }
    if (!data || !data.sizes || !data.sizes.length) return;
    render(row, data);
  }

  /* SIZES WE DO NOT SELL. Adam's call 25 Aug 2026, the day the shirts moved onto one
     fixed printer (Monster Digital): "4XL and 5XL drop from the shirt, he accepted that."
     The products on Shopify still carry those variants, so every buy row that reads a
     product live was still offering them, and the price climbed at 4XL and 5XL. His catch
     3 Sep 2026. One list, used by both ways a row gets its data (the Liquid snippet's
     JSON and the live fetch), so no shelf can ever drift from another. */
  var NOT_SOLD = ['4XL', '5XL'];

  function render(row, data) {
    if (data && data.sizes) {
      data.sizes = data.sizes.filter(function (s) { return NOT_SOLD.indexOf(s) === -1; });
      if (!data.sizes.length) return;
    }
    var imgs = cardImages(row);
    var onPage = row.getAttribute('data-wr-page') === 'product';

    /* START ON THE COLOUR THE CARD IS ALREADY SHOWING.
       The home page picks its photos by colour before this row is drawn, so a
       card can be showing the gray shirt. Without this the ring sat on the
       black dot over a gray photo. Any card that does not say otherwise is
       showing photo one, which is the black one.
       If he has already chosen on this shirt once, that beats everything. */
    var memory = lastPick[data.u] || {};
    var color = memory.c || row.getAttribute('data-wr-color') || '';
    var known = false;
    (data.colors || []).forEach(function (c) {
      if (c.n.toLowerCase() === String(color).toLowerCase()) { color = c.n; known = true; }
    });
    if (!known) color = data.colors && data.colors.length ? data.colors[0].n : '';

    /* the size he last chose on this shirt, so a redrawn button can be born green */
    var size = memory.s || '';

    /* HAS HE ACTUALLY PRESSED A COLOUR, OR IS THE CARD JUST SHOWING ONE?
       Adam's rule, 7 Sep 2026 late. Until then a colour LOOKED chosen, because
       the card is showing a photo of one and the ring sat on that dot, and a
       size press put the shirt straight in the cart. His words: "so if he then
       wants a different colour it is too late, the shirt is already in".

       So the colour above is now only the colour SHOWING. This is the separate
       thing: whether he has pressed a dot. At rest it is false, no dot is
       ringed, and nothing can go in the cart. A shirt that only comes one way
       has no dots at all, so there is nothing to press and it counts as
       chosen. */
    var oneColour = !(data.colors && data.colors.length > 1);
    var colorPicked = oneColour || !!memory.p;

    var hr = el('div', 'wr-buy__hr');
    var bar = el('div', 'wr-buy__bar');
    var price = el('div', 'wr-buy__price', data.p || '');

    /* THE BUTTON ON THE ROW ONLY OPENS THE CHOICES, so it says so. "Pick a
       size." is his own, 2 Oct 2026. It read ADD from 29 Aug 2026, and ADD is
       exactly what his brief took off it: "if a button only opens the choices,
       call it [that], not Add to cart". Its words never change and it never
       turns ADDED; what is in the cart is told by the mark on the photo. */
    var add = el('button', 'wr-buy__add', 'Pick a size.');
    add.type = 'button';

    var panel = el('div', 'wr-buy__panel');
    var panelIn = el('div', 'wr-buy__panelin');
    panel.appendChild(panelIn);

    /* the variant for the colour SHOWING and the size lit. Used for the price,
       which follows the size whether or not a dot has been pressed. */
    function pairNow() {
      return size ? data.map[color + '|' + size] : null;
    }

    /* the variant he has actually CHOSEN: both a dot and a size pressed. This
       is the only thing the Add to cart button will ever send. */
    function chosenPair() {
      return (colorPicked && size) ? data.map[color + '|' + size] : null;
    }

    function remember() {
      lastPick[data.u] = { c: color, s: size, p: colorPicked };
    }

    /* a shirt is on its way into the cart: Add to cart waits for the answer */
    var busy = false;

    /* THE ROW SHOWS THE CHOICE AS IT STANDS, and that is all this does. It is
       called after every press and when the row is first drawn.
       THE PRICE FOLLOWS THE SIZE. 2XL and 3XL cost more, and until a size is
       chosen the row shows the shirt's starting price.
       ADD TO CART WAKES UP only when a colour and a size are both pressed and
       that exact pair can be bought. */
    function syncRow() {
      var pair = pairNow();
      var mine = chosenPair();
      price.textContent = (pair && pair[2]) ? pair[2] : (data.p || '');
      if (!busy) put.disabled = !(mine && mine[1] === 1);
    }

    function openPanelHere() {
      if (openPanel && openPanel !== panel) shutPanel();
      panel.classList.add('is-open');
      openPanel = panel;
    }

    function closePanelHere() {
      if (openPanel === panel) shutPanel();
      else panel.classList.remove('is-open');
    }

    function markDots() {
      if (!dots) return;
      Array.prototype.forEach.call(dots.children, function (d) {
        d.classList.toggle('is-on', colorPicked && d.title === color);
      });
    }

    /* THE COLOUR DOTS. Skipped when a product only comes one way. Sit in the
       middle, his call 4 Sep 2026, phone and computer both. */
    var dots = null;
    if (data.colors && data.colors.length > 1) {
      panelIn.appendChild(el('p', 'wr-buy__label', 'COLOUR'));
      dots = el('div', 'wr-buy__dots');
      data.colors.forEach(function (c) {
        var d = el('button', 'wr-buy__dot');
        d.type = 'button';
        d.title = c.n;
        d.setAttribute('aria-label', c.n);
        /* THE COLOUR IS HANDED OVER AS --wr-dot, NOT AS A BACKGROUND.
           There is a site-wide line in the theme settings that wipes ANY inline
           colour or background inside the page body, everywhere except the two
           home page sections:
             main [style*="color"]:not(.wrhr *):not(.wrhp *),
             main [style*="background"]:not(.wrhr *):not(.wrhp *)
               { color: #fff !important; background: transparent !important; }
           So painting the dot with style.background made every dot come out
           see-through, which on a black card reads as three black dots. That is
           exactly what Adam saw on the strip at the bottom of a shirt page,
           4 Sep 2026. The name --wr-dot holds neither "color" nor "background",
           so that line cannot match this element at all. Never put a colour
           straight into a style attribute anywhere on this site. */
        var fill = el('i');
        fill.style.setProperty('--wr-dot', swatchFor(c.n));
        d.appendChild(fill);
        /* NO RING AT REST. His rule 7 Sep 2026: nothing is marked until he
           presses it, so the card never pretends a colour is chosen. */
        if (colorPicked && c.n === color) d.classList.add('is-on');
        /* A PRESS ON A DOT CHOOSES A COLOUR AND NOTHING MORE. The ring moves,
           the photo turns to that colour, the sizes are drawn again for it.
           Nothing goes near the cart, his brief 2 Oct 2026. */
        d.addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          color = c.n;
          colorPicked = true;
          /* a size this colour cannot be bought in does not stay lit */
          var still = size ? data.map[color + '|' + size] : null;
          if (size && (!still || still[1] !== 1)) size = '';
          markDots();
          if (onPage) jumpGallery(row, c.m);
          else showPhoto(imgs, c.img);
          drawSizes();
          remember();
          hush();
          syncRow();
        });
        dots.appendChild(d);
      });
      panelIn.appendChild(dots);
    }

    /* THE SIZES. Chips, three across on a phone, all in one row on a computer
       (that is CSS). A size that is sold out in the colour showing is greyed
       and does nothing. The chips are redrawn whenever the colour changes,
       because a colour can be sold out in one size and not another. */
    panelIn.appendChild(el('p', 'wr-buy__label', 'SIZE'));
    var sizes = el('div', 'wr-buy__sizes');
    panelIn.appendChild(sizes);

    function drawSizes() {
      sizes.innerHTML = '';
      data.sizes.forEach(function (s) {
        var pair = data.map[color + '|' + s];
        var b = el('button', 'wr-buy__size', s);
        b.type = 'button';
        if (!pair || pair[1] !== 1) b.disabled = true;
        /* THE BOX LIGHTS UP BECAUSE HE PRESSED IT. His rule 7 Sep 2026: a size
           press is a choice on its own and shows as one. */
        if (s === size) b.classList.add('is-on');
        /* A PRESS ON A SIZE CHOOSES A SIZE AND NOTHING MORE, the same as a dot. */
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          if (b.disabled) return;
          size = s;
          remember();
          drawSizes();
          hush();
          syncRow();
        });
        sizes.appendChild(b);
      });
    }
    drawSizes();

    /* THE SEPARATE ADD TO CART BUTTON. His brief 2 Oct 2026: "Selecting options
       must not add, remove, or replace anything in their cart. They press a
       separate Add to cart button. It becomes available once valid choices are
       selected." This replaces "the second of the two presses is what buys"
       (7 Sep 2026) and with it the swap, where changing a colour afterwards
       took the old shirt out and put the new one in. */
    var put = el('button', 'wr-buy__put', 'Add to cart');
    put.type = 'button';
    put.disabled = true;
    panelIn.appendChild(put);

    /* his own words for an add that failed, off the list of the site's small
       messages he passed on 14 Aug 2026 (the theme's own add button says the
       same, and "Adding." while it waits). Out of sight until it is needed,
       and gone again at the next press. */
    var oops = el('p', 'wr-buy__oops', 'That did not work. Try again.');
    panelIn.appendChild(oops);
    function hush() { oops.classList.remove('is-on'); }

    function photoOf(name) {
      var hit = (data.colors || []).filter(function (c) { return c.n === name; })[0];
      return hit ? hit.img : '';
    }

    /* PUTTING IT IN. One shirt, Shopify's own /cart/add.js, and nothing else:
       no swap, nothing taken out. Choosing the same colour and size again and
       pressing Add to cart again makes it two, the way any shop's button does.

       IF IT FAILS the shirt is not in the cart, the row says so in his words
       and waits, and the choice stays lit so one more press tries again. It
       used to send the shopper to the shirt's own page instead ("a sale we
       must not lose"), but since 26 Sep 2026 that page shows the "We are not
       open yet." note where its own add button was, so there is nothing there
       to fall back on. */
    function putIn(id) {
      busy = true;
      put.disabled = true;
      put.textContent = 'Adding.';
      hush();
      /* what the box will say, taken NOW: the choice is cleared the moment the
         shirt is in */
      var said = {
        name: data.t || '',
        color: oneColour ? '' : color,
        size: size,
        price: price.textContent,
        img: sized(photoOf(color), 400),
        back: add
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: cartSectionIds().join(',') })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function (response) {
          busy = false;
          put.textContent = 'Add to cart';
          addedIds[id] = (addedIds[id] || 0) + 1;
          var line = lineOf(response, id);
          if (line && line.product_title) said.name = line.product_title;
          if (!said.img && line && line.image) said.img = sized(line.image, 400);
          /* the card folds shut and lets the choice go: the next one is fresh */
          colorPicked = oneColour;
          size = '';
          remember();
          markDots();
          drawSizes();
          closePanelHere();
          syncRow();
          syncAll();
          showAdded(said);
          var counted = bumpCartCount();
          tellCart('add', response, counted);
        }, function () {
          busy = false;
          put.textContent = 'Add to cart';
          oops.classList.add('is-on');
          syncRow();
        });
    }

    put.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      var chosen = chosenPair();
      if (busy || !chosen || chosen[1] !== 1) return;
      putIn(chosen[0]);
    });

    /* THE ROW'S OWN BUTTON OPENS AND SHUTS THE PANEL. That is all it has done
       since 7 Sep 2026 ("taking something out happens in the cart only"), and
       since 2 Oct 2026 it is all it says it does. */
    add.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      if (panel.classList.contains('is-open')) closePanelHere();
      else openPanelHere();
    });

    bar.appendChild(price);
    bar.appendChild(add);
    row.appendChild(hr);
    row.appendChild(bar);
    row.appendChild(panel);

    /* IS ANY COLOUR OR SIZE OF THIS SHIRT IN THE CART? Then its photo carries
       the mark. Read off the real cart, so the mark is there on every page he
       comes back to and gone when the last one is taken out in the bag. The
       card itself stays at rest: no dot ringed, no size lit, the photo the
       page dealt. (Until 2 Oct 2026 a card whose shirt was in the bag moved
       itself onto that colour and size and drew its button green; with the
       green gone that only left a card looking half chosen.) */
    function markCart() {
      var has = false;
      Object.keys(data.map).forEach(function (key) {
        var pair = data.map[key];
        if (pair && addedIds[pair[0]]) has = true;
      });
      setMark(row, has);
    }

    function syncFromCart() {
      markCart();
      syncRow();
    }
    syncers.push(syncFromCart);

    /* draw the row once now, then mark it the moment the real cart is known */
    syncRow();
    cartReady.then(syncFromCart);
  }

  /* THE ONE SHIRT AND ONE HOODIE FEATURES ON THE HOME PAGE.
     Those two features (Back and Next arrows, swatches, size buttons, a
     quantity, one ADD) are drawn by the home page sections themselves, not by
     this row, and each section carries its own little add script: add only,
     green painted on by hand, no memory, no way back out. Adam's catch,
     4 Sep 2026: "on the one shirt it doesn't work like this, also I cannot
     remove it". The sections are built from a mockup and rebuilt from it, so
     a fix written into them would be wiped on the next rebuild. So the fix
     lives here: this script takes those ADD buttons over. It listens on the
     button in the capture phase, which runs first, and stops the section's own
     handler from ever firing. From then on the button is this script's: ADDED
     if the chosen colour and size is in the cart (read off the real cart, so
     it survives leaving the page), every press puts it in with the quantity
     chosen, ADDED or not, and the bag redraws. Pressing ADDED never takes it
     out, his call 7 Sep 2026: that happens in the cart only.
     The section's own swatches, sizes, arrows and quantity are left alone;
     the button re-reads them every time it needs to know what is chosen.

     SINCE 2 Oct 2026 THE CARDS AND THESE TWO PART WAYS ON ONE THING AND MEET ON
     ANOTHER. A card's button only opens the choices now and never turns ADDED;
     these keep ADDED, because here the colours and sizes are already on show
     and this button is the one that buys. But a shirt that goes in from here
     opens the same Added to cart box a card opens, so the shop says it the
     same way wherever it is added from. (4 Sep 2026 is why: "on the one shirt
     it doesn't work like this".) */
  var productCache = {};

  function productJson(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .catch(function () { delete productCache[handle]; return null; });
    }
    return productCache[handle];
  }

  function cartAdd(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }], sections: cartSectionIds().join(',') })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (json) { return { action: 'add', json: json }; });
  }

  /* what the feature has chosen right now: the product (the section writes it
     on the box as data-handle and changes it with the arrows), the colour, the
     size and the quantity. Phone and computer sections use different class
     names for the same things, both are read. */
  function featureBits(btn) {
    var box = btn.closest('[data-handle]');
    if (!box) return null;
    var sw = box.querySelector('.wrhp-swatch.wrhp-on, .wrhr-swatch.wrhr-on');
    var color = sw ? (sw.getAttribute('data-color') || '') : '';
    color = color.charAt(0).toUpperCase() + color.slice(1);
    var sizeEl = box.querySelector('.wrhp-sizebtn.wrhp-on, .wrhr-sizebtn.wrhr-on');
    var size = sizeEl ? sizeEl.textContent.trim() : '';
    var qtyEl = box.querySelector('.wrhp-qty__n, .wrhr-qty__n');
    var qty = qtyEl ? (parseInt(qtyEl.textContent, 10) || 1) : 1;
    return { handle: box.dataset.handle, color: color, size: size, qty: qty, box: box };
  }

  function featureVariant(bits) {
    if (!bits || !bits.handle || !bits.color || !bits.size) return Promise.resolve(null);
    return productJson(bits.handle).then(function (p) {
      if (!p || !p.variants) return null;
      return p.variants.filter(function (x) {
        return x.options.indexOf(bits.size) !== -1 && x.options.indexOf(bits.color) !== -1;
      })[0] || null;
    });
  }

  function paintFeature(btn, on) {
    /* the section's own script painted its green straight onto the style
       attribute; that is cleared so the class below is the only thing talking */
    btn.style.removeProperty('background');
    btn.style.removeProperty('color');
    if (on) { btn.classList.add('is-done'); btn.textContent = 'ADDED'; }
    else { btn.classList.remove('is-done'); btn.textContent = 'ADD'; }
  }

  function attachFeature(btn) {
    if (btn.dataset.wrBuyFeature === '1') return;
    btn.dataset.wrBuyFeature = '1';
    var busy = false;

    function sync() {
      featureVariant(featureBits(btn)).then(function (v) {
        if (busy) return;
        paintFeature(btn, !!(v && addedIds[v.id]));
      });
    }
    syncers.push(sync);
    cartReady.then(sync);

    var box = btn.closest('[data-handle]');
    if (box) {
      /* a new colour or size was picked: the section's own handler moves the
         "on" mark first, then this re-reads it */
      box.addEventListener('click', function (e) {
        var t = e.target && e.target.closest ? e.target.closest('.wrhp-swatch, .wrhr-swatch, .wrhp-sizebtn, .wrhr-sizebtn') : null;
        if (t) setTimeout(sync, 0);
      });
      /* Back or Next: the section writes the new product onto the box */
      if (window.MutationObserver) {
        new MutationObserver(function () { sync(); }).observe(box, { attributes: true, attributeFilter: ['data-handle'] });
      }
    }

    btn.addEventListener('click', function (e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      if (busy) return;
      var bits = featureBits(btn);
      if (!bits || !bits.color || !bits.size) return;
      busy = true;
      btn.disabled = true;
      featureVariant(bits)
        .then(function (v) {
          if (!v) { btn.textContent = 'NOT AVAILABLE'; return null; }
          if (!v.available) { btn.textContent = 'NOT AVAILABLE'; return null; }
          return cartAdd(v.id, bits.qty).then(function (res) { addedIds[v.id] = true; res.variant = v; return res; });
        })
        .then(function (res) {
          busy = false;
          btn.disabled = false;
          if (res) {
            tellCart(res.action, res.json, bumpCartCount());
            sync();
            syncAll();
            /* the same box the cards open. The price is the one Shopify charged
               for the line; more than one shows as "M x 2" beside the size. */
            var line = lineOf(res.json, res.variant.id);
            var cents = (line && typeof line.final_price === 'number') ? line.final_price : res.variant.price;
            var shot = (line && line.image) || (res.variant.featured_image && res.variant.featured_image.src) || '';
            showAdded({
              name: (line && line.product_title) || '',
              color: bits.color,
              size: bits.size + (bits.qty > 1 ? ' × ' + bits.qty : ''),
              price: priceLike('$0', cents),
              img: sized(shot, 400),
              back: btn
            });
          }
        })
        .catch(function () {
          busy = false;
          btn.disabled = false;
          btn.textContent = 'TRY AGAIN';
        });
    }, true);
  }

  function scan(root) {
    var where = root || document;
    Array.prototype.forEach.call(
      where.querySelectorAll('.wr-buy[data-wr-buy], .wr-buy[data-wr-handle]'),
      build
    );
    Array.prototype.forEach.call(
      where.querySelectorAll('.wrhp-feature__add, .wrhr-feature__add'),
      attachFeature
    );
  }

  window.wrBuy = { scan: scan, build: build };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  /* collection pages swap their grid in without reloading, so watch for
     cards that arrive later.
     Measured on the live shop 8 Sep 2026: the page changes over a hundred times on one
     visit, and every single change used to send this looking over the whole page again.
     It now waits for the next screen frame and looks once, so a hundred looks become a
     few. Nothing about WHAT is looked for changes, only how often. The longest a brand
     new buy row can sit unwired is one frame, about a hundredth of a second. */
  if (window.MutationObserver) {
    var scanQueued = false;
    var soon = window.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); };
    new MutationObserver(function () {
      if (scanQueued) return;
      scanQueued = true;
      soon(function () { scanQueued = false; scan(); });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
